module.exports = __webpack_public_path__ + "static/media/ticket_illustration.65990d29.png";